export function useTruncation(text: string, length: number): string {
    return text.length > length ? text.trim().slice(0, length) + '...' : text;
}
